<template>
  <div class="top-bar">
    <div class="title">{{ $store.pageTitle[$route.path] }}</div>
    <div class="opt">
      <el-button icon="el-icon-refresh" @click="refresh()" size="mini"
        >刷新</el-button
      >
      <el-button icon="el-icon-arrow-left" size="mini" @click="back()"
        >返回</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  inject: ['refresh'],
  data() {
    return {}
  },
  mounted() {},
  methods: {
    back() {
      this.$router.go(-1)
    },
  },
}
</script>
